import React from 'react'
import { Divider, Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ContentHistory } from '@fs/zion-icon'
import { useSlsStateContext } from '@fs/zion-sls'
import { useR2StateContext } from '../../../../providers/r2Provider/R2Context'

export default function ShowChangeHistory({ showIcon = true }) {
  const state = useSlsStateContext()
  const r2State = useR2StateContext()
  const [t] = useTranslation()

  return (
    <>
      <Divider marginY="nano" fullWidth />
      <Button
        Icon={showIcon ? ContentHistory : undefined}
        to={`/ark:/61903/${state.currentImageArk}?view=history${
          r2State.selectedPersonId ? `&personArk=${r2State.selectedPersonId}` : ''
        }`}
      >
        {t('view-history-show-change-history-button', 'Show Change History')}
      </Button>
    </>
  )
}
